import React, { useCallback, useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react'
import { Empty } from 'antd'
import moment from 'moment'
import SalaryVpDetailModal from './SalaryVpDetailModal'
import TableComponent from '../../components/Common/TableComponent'

const MySalaryVpList = props => {
  const { salaryVpStore } = props
  const { mySalaryVpList, getMySalaryVpList, mySalaryVpQuery } = salaryVpStore
  const [loading, setLoading] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [isModalVisible, setIsModalVisible] = useState(false)

  const formatCurrencyCell = val => {
    if (val === null || val === undefined || val === '') return '-'
    const numericValue =
      typeof val === 'number'
        ? val
        : Number(String(val).replace(/[^0-9,.-]/g, '').replace(/,/g, ''))
    if (!Number.isFinite(numericValue)) return '-'
    return new Intl.NumberFormat().format(numericValue)
  }

  const fetchData = useCallback(async () => {
    setLoading(true)
    try {
      await getMySalaryVpList()
    } finally {
      setLoading(false)
    }
  }, [getMySalaryVpList])

  useEffect(() => {
    fetchData()
  }, [fetchData, mySalaryVpQuery.page, mySalaryVpQuery.size])

  const columns = [
    {
      title: 'Mã nhân viên',
      key: 'ma_nv',
      align: 'center',
      render: record => record.raw_data?.ma_nv,
    },
    {
      title: 'Họ và tên',
      key: 'ho_va_ten',
      render: record => record.raw_data?.ho_va_ten,
    },
    {
      title: 'Ngày công',
      key: 'ngay_cong',
      align: 'center',
      render: record => record.raw_data?.ngay_cong,
    },
    {
      title: 'Thu nhập tiền lương thực lĩnh',
      key: 'thu_nhap_thuc_linh',
      align: 'right',
      render: record => <span>{formatCurrencyCell(record.raw_data?.thu_nhap_thuc_linh)}</span>,
    },
    {
      title: 'Ngày đăng',
      dataIndex: 'salary_month',
      key: 'salary_month',
      align: 'center',
      render: text => (text ? moment(text).format('DD/MM/YYYY') : '-'),
    },
  ]

  const handleRowClick = record => {
    setSelectedRecord({
      ...record.raw_data,
      salary_month: record.salary_month,
      salary_request_code: record.salary_request_code,
    })
    setIsModalVisible(true)
  }

  return (
    <div className="my-salary-vp-list">
      <h3 style={{ marginBottom: 16 }}>Danh sách lương CBNV Văn phòng</h3>
      <TableComponent
        dataSource={mySalaryVpList}
        columns={columns}
        rowKey={record =>
          `${record.salary_request_code}_${record.raw_data?.ma_nv}`
        }
        loading={loading}
        onRow={record => ({
          onClick: () => handleRowClick(record),
          style: { cursor: 'pointer' },
        })}
        pagination={{
          current: mySalaryVpQuery.page + 1,
          pageSize: mySalaryVpQuery.size,
          total: salaryVpStore.mySalaryVpTotal,
          onChange: (page, pageSize) => {
            salaryVpStore.setMySalaryVpQuery({ page: page - 1, size: pageSize })
          },
        }}
        locale={{
          emptyText: <Empty description="Chưa có dữ liệu lương" />,
        }}
      />
      <SalaryVpDetailModal
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        data={selectedRecord}
      />
    </div>
  )
}

export default inject('salaryVpStore')(observer(MySalaryVpList))
